import translations1 from '../../priv/gettext/default_js.pot'
import translations2 from '../../priv/gettext/default_reactjs.pot'

const mergedTranslations = {
  headers: translations1.headers,
  messages: {}
}

const locales = Object.keys(translations1.messages)

// The current locale is read from html["lang"] (see steady_gettext.js)
locales.forEach(locale => {
  mergedTranslations.messages[locale] = { ...translations1.messages[locale], ...translations2.messages[locale] }
})

export default mergedTranslations
